var _desc, _style, _circle, _ellipse, _g, _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _path6, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-state-title"
  }, "Ei viel\xE4 sis\xE4lt\xF6\xE4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-state-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-state-desc"
  }, "Avoin tyhj\xE4 laatikko, jonka yll\xE4 leijuu tyhj\xE4 kortti")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-state-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-state-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-state-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-state-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-state-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-state-float  { animation: empty-state-float 4s ease-in-out 2; transform-origin: center; }\n    @keyframes empty-state-float   { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }\n    @media (prefers-reduced-motion: reduce) { .empty-state-float { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 84,
    className: "empty-state-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 168,
    rx: 52,
    ry: 6,
    className: "empty-state-accent",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-state-float"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 36,
    width: 52,
    height: 40,
    rx: 7,
    className: "empty-state-surface empty-state-stroke",
    strokeWidth: 2,
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 50,
    x2: 128,
    y2: 50,
    className: "empty-state-line",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 60,
    x2: 136,
    y2: 60,
    className: "empty-state-line",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 112 L92 98 H148 L160 112 Z",
    className: "empty-state-accent",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112 L92 98 L74 84 L60 99 Z",
    className: "empty-state-surface empty-state-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 112 L148 98 L166 84 L180 99 Z",
    className: "empty-state-surface empty-state-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 112,
    width: 80,
    height: 54,
    rx: 5,
    className: "empty-state-surface empty-state-stroke",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 112,
    width: 80,
    height: 10,
    className: "empty-state-accent",
    opacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 134,
    width: 24,
    height: 6,
    rx: 3,
    className: "empty-state-accent",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "empty-state-accent empty-state-twinkle",
    d: "M56 58 l2.5 6.5 6.5 2.5 -6.5 2.5 -2.5 6.5 -2.5 -6.5 -6.5 -2.5 6.5 -2.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "empty-state-accent empty-state-twinkle empty-state-b",
    d: "M186 50 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "empty-state-accent empty-state-twinkle empty-state-c",
    d: "M182 128 l1.6 4 4 1.6 -4 1.6 -1.6 4 -1.6 -4 -4 -1.6 4 -1.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 132,
    r: 3,
    className: "empty-state-accent",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 74,
    r: 2.5,
    className: "empty-state-accent",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.5282baf22f95084ee7df6aa0d281a944.svg";
export { ForwardRef as ReactComponent };